import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate, useParams } from 'react-router-dom'
import {
  PortalContext, usePortal, usePortalContext, portalDetailPath, portalRepoPath,
} from './olivium/portal-factory'

/**
 * Portal project-context route wrapper (PHASE_2L).
 *   /square/command-center/olivium/portals/:portalId/context
 *
 * Owns usePortalContext (repo/deploy metadata + client-access bridge) and
 * usePortal (for the portal name). Honest states; nothing fabricated.
 */
export default function SquareCodePortalContextRoute() {
  const navigate = useNavigate()
  const { portalId } = useParams<{ portalId: string }>()
  const id = portalId || ''
  const portal = usePortal(portalId)
  const ctx = usePortalContext(portalId)

  return (
    <PortalContext
      portalName={portal.detail?.portal.project_name}
      context={ctx.context}
      loading={ctx.loading}
      error={ctx.error}
      authRequired={ctx.authRequired}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenPortal={() => navigate(portalDetailPath(id))}
      onOpenRepo={() => navigate(portalRepoPath(id))}
      onSaveNextAction={(text: string) => ctx.save({ next_action: text })}
      onPublish={(visible: boolean) => ctx.publish(visible)}
    />
  )
}
